import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { exportImage } from '@progress/kendo-drawing';
import $ from "jquery";

var optionsIntervaloSelosGarantia = [];

var optionSelected = null;

var thisIntervaloSelos = null;

class DropDownCellIntervaloSelosGarantia extends Component {
  
  static getAllData() {

    (async () => {

      optionsIntervaloSelosGarantia = [];

      const data = {"idEntidade" : localStorage.EntidadeSelected}
      const Intervalo = await services.apiCall.requestApi(
          "/Selos/GetSelosDisponiveisAposicao",
          data,
          "get"
      );

      if(Intervalo != null){
        Intervalo.map((data) => (
          optionsIntervaloSelosGarantia.push({text: data.serie + " " + data.intervalo, value: data.idOperacaoSelos})
        ));
        $("#k-loading-mask Display_loadiing").css("display" , "none");
        

      }
    })();


  }

  static returnValue () {
    return optionSelected;
  }

  handleChange = e => {
    
    optionSelected = e.value;

    $("#seloInicial").each(function(){
      $(this).attr({
        "max" : parseInt(e.value.text.split(' ')[1].split('-')[1]),
        "min" : parseInt(e.value.text.split(' ')[1].split('-')[0])
      });
    });

   // $("#seloFinal").val(parseInt(e.value.text.split(' ')[1].split('-')[1]));
    $("#seloInicial").val(e.value.text.split(' ')[1].split('-')[0]);

  }


  render() {

    DropDownCellIntervaloSelosGarantia.getAllData();

    $("#seloInicial").val(null)
   // $("#seloFinal").val(null)


    console.log("DropDownCellSelosGarantia")
    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem != null ? dataItem[field] === null ? '' : dataItem[field] : '';

    thisIntervaloSelos = this;

    return (
      
      <DropDownList
        popupSettings={{
          width: 'max-content',
        }}
        onChange={this.handleChange}
        data={optionsIntervaloSelosGarantia}
        textField="text"
        id='id-DropDownCellIntervaloSelosGarantia'
      />
    
      

    );
  }
    
}

export default DropDownCellIntervaloSelosGarantia;